import { IEmployeeRoleByIdType } from "./type"

const employeeBaseUrl = "/employee/roles"

export const employeeRoleByIdUrl = (params: IEmployeeRoleByIdType) => {
    return `${employeeBaseUrl}/${params.roleTypeId}`
}
